import { useAsync } from '@react-hookz/web';
import { AuthenticationService } from '@root/Services/AuthenticationService';
import { CompanyUserService, UserRecord } from '@root/Services/Customers/CompanyUserService';
import { useDiMemo } from '@root/Services/DI';
import { useEffect, useState } from 'react';

export function useCurrentUser() {
    const authNSvc = useDiMemo(AuthenticationService);
    return authNSvc.user;
}

export function useCompanyUserList() {
    const userSvc = useDiMemo(CompanyUserService);
    const [{ status, result: userList }, { execute }] = useAsync(() => userSvc.getUserList());
    useEffect(() => {
        execute();
    }, []);

    return { loading: status === 'loading', userList };
}

/**
 * Get user record, which includes the active state of the user for the current company.
 * @param id The user id, or undefined to get the current user.
 */
export function useUser(id?: number) {
    const { userList, loading } = useCompanyUserList();
    const currentUser = useCurrentUser();
    const [user, setUser] = useState<UserRecord>();
    useEffect(() => {
        if (userList) {
            const user = userList.getById(id ?? currentUser?.Id ?? 0);
            setUser(user);
        }
    }, [id, userList]);
    return { userList, user, loading };
}
